import React, { memo, forwardRef } from "react";
const SvgAlphabetB = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.73 18.67c0-.373-.06-.74-.18-1.1a2.94 2.94 0 00-.5-1 2.46 2.46 0 00-.86-.7c-.347-.187-.753-.28-1.22-.28-.44 0-.833.093-1.18.28a3.154 3.154 0 00-.9.72c-.24.293-.427.627-.56 1-.12.373-.18.747-.18 1.12 0 .373.06.747.18 1.12.133.36.32.687.56.98.253.293.553.533.9.72.347.173.74.26 1.18.26.467 0 .873-.093 1.22-.28.347-.187.633-.427.86-.72a2.94 2.94 0 00.5-1c.12-.373.18-.747.18-1.12zm-7.9-9.12c0-.28.04-.507.12-.68.093-.187.2-.327.32-.42.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v5.58h.06a3.832 3.832 0 011.12-.98 4.13 4.13 0 01.92-.36c.347-.107.74-.16 1.18-.16.68 0 1.307.133 1.88.4a4.368 4.368 0 011.48 1.06c.413.453.733.987.96 1.6.227.613.34 1.273.34 1.98 0 .707-.113 1.373-.34 2a4.79 4.79 0 01-.94 1.62c-.4.453-.893.82-1.48 1.1-.573.267-1.227.4-1.96.4-.68 0-1.32-.147-1.92-.44a3.28 3.28 0 01-1.38-1.28h-.04v.36c0 .267-.047.487-.14.66-.08.16-.18.287-.3.38a.906.906 0 01-.38.18c-.12.027-.227.04-.32.04s-.207-.013-.34-.04a.915.915 0 01-.36-.18 1.306 1.306 0 01-.32-.38 1.578 1.578 0 01-.12-.66V9.55z"
      />
    </svg>
  );
});
SvgAlphabetB.displayName = "SvgAlphabetB";
const MemoForwardRef = memo(SvgAlphabetB);
export default MemoForwardRef;
